(() => {
  if (window.PhotoPrintOptions) return;
  const testCartItem = item => item?.orderable ? {id:String(item.id).split('/').pop(),quantity:1,properties:{...item.properties}} : null;
  const applyFrameFinish = (frame, geometry, finish) => {
    if (!frame?.ownerDocument) return;
    const faces = [...frame.querySelectorAll(':scope > .photo-frame-face')];
    if (geometry?.supplier !== 'simply-framed') {
      faces.forEach(face => face.remove());
      delete frame.dataset.finish;
      return;
    }
    frame.dataset.finish = finish;
    const x = geometry.profile.face / geometry.outerIn[0] * 100;
    const y = geometry.profile.face / geometry.outerIn[1] * 100;
    const shapes = {
      top: {left:'0',top:'0',width:'100%',height:y+'%',clipPath:`polygon(0 0,100% 0,${100-x}% 100%,${x}% 100%)`},
      bottom: {left:'0',bottom:'0',width:'100%',height:y+'%',clipPath:`polygon(${x}% 0,${100-x}% 0,100% 100%,0 100%)`},
      left: {left:'0',top:'0',width:x+'%',height:'100%',clipPath:`polygon(0 0,100% ${y}%,100% ${100-y}%,0 100%)`},
      right: {right:'0',top:'0',width:x+'%',height:'100%',clipPath:`polygon(0 ${y}%,100% 0,100% 100%,0 ${100-y}%)`}
    };
    for (const [side, style] of Object.entries(shapes)) {
      let face = faces.find(node => node.dataset.frameFace === side);
      if (!face) {
        face = frame.ownerDocument.createElement('span');
        face.className = 'photo-frame-face photo-frame-face--' + side;
        face.dataset.frameFace = side;
        face.setAttribute('aria-hidden','true');
        frame.prepend(face);
      }
      Object.assign(face.style,style);
    }
  };
  const applyPreviewGeometry = (frame, mat, image, geometry, room = false, viewport = null, core = null) => {
    if (core) core.style.display = 'none';
    for (const [element, keys] of [[frame, ['padding', 'aspectRatio', 'position', 'containerType']], [mat, ['aspectRatio', 'padding', 'position', 'left', 'top', 'width', 'height']], [image, ['position', 'left', 'top', 'width', 'height', 'objectFit', 'boxShadow']]]) {
      keys.forEach(key => { element.style[key] = ''; });
    }
    if (viewport) ['position','left','top','width','height','overflow','boxShadow'].forEach(key => { viewport.style[key] = ''; });
    if (!geometry) return;
    const supplier = geometry.supplier === 'simply-framed';
    const outer = supplier ? geometry.outerIn : geometry.outerCm;
    const paper = supplier ? geometry.interiorIn : geometry.paperCm;
    const printed = supplier ? geometry.imageIn : geometry.imageCm;
    const opening = supplier ? geometry.windowIn : printed;
    const coreBevelIn = 1 / 32;
    if (!outer || !paper || !printed || !opening) return;
    frame.style.padding = '0';
    frame.style.position = room ? 'absolute' : 'relative';
    frame.style.aspectRatio = outer.join(' / ');
    if (supplier) frame.style.containerType = 'inline-size';
    mat.style.padding = '0';
    mat.style.position = 'absolute';
    const matWidth = supplier ? outer[0] - geometry.profile.face * 2 : paper[0];
    const matHeight = supplier ? outer[1] - geometry.profile.face * 2 : paper[1];
    mat.style.left = (outer[0] - matWidth) / 2 / outer[0] * 100 + '%';
    mat.style.top = (outer[1] - matHeight) / 2 / outer[1] * 100 + '%';
    mat.style.width = matWidth / outer[0] * 100 + '%';
    mat.style.height = matHeight / outer[1] * 100 + '%';
    const target = viewport || image;
    target.style.position = 'absolute';
    target.style.left = (matWidth - opening[0]) / 2 / matWidth * 100 + '%';
    target.style.top = (matHeight - opening[1]) / 2 / matHeight * 100 + '%';
    target.style.width = opening[0] / matWidth * 100 + '%';
    target.style.height = opening[1] / matHeight * 100 + '%';
    if (viewport) {
      viewport.style.overflow = 'hidden';
      const bevel = (coreBevelIn * 100 / outer[0]).toFixed(9) + 'cqw';
      viewport.style.boxShadow = supplier && geometry.mat === 'black' && !core ? '0 0 0 ' + bevel + ' #f5f4ef' : '';
      if (core && supplier && geometry.mat === 'black') {
        // Draw the bevel as a filled physical ring outside the aperture, above the
        // photograph. Percentage SVG strokes and tiny CSS shadows can rasterize
        // asymmetrically or be clipped. No pixel floor changes the physical width.
        Object.assign(core.style, {display:'block',position:'absolute',left:target.style.left,top:target.style.top,width:target.style.width,height:target.style.height,overflow:'visible',pointerEvents:'none',zIndex:'1',strokeWidth:bevel});
        if (core.ownerDocument) {
          const [w,h] = opening, b = coreBevelIn;
          core.setAttribute('viewBox', `0 0 ${w} ${h}`);
          core.setAttribute('preserveAspectRatio', 'none');
          let ring = core.querySelector('[data-core-ring]');
          if (!ring) {
            ring = core.ownerDocument.createElementNS('http://www.w3.org/2000/svg','path');
            ring.dataset.coreRing = '';
            core.replaceChildren(ring);
          }
          ring.setAttribute('d', `M${-b},${-b}H${w+b}V${h+b}H${-b}Z M0,0V${h}H${w}V0Z`);
          ring.setAttribute('fill', '#ffffff');
          ring.setAttribute('fill-rule', 'evenodd');
          ring.setAttribute('stroke', 'none');
          ring.setAttribute('shape-rendering', 'geometricPrecision');
        }
      }
      image.style.position = 'absolute';
      image.style.left = -(printed[0] - opening[0]) / 2 / opening[0] * 100 + '%';
      image.style.top = -(printed[1] - opening[1]) / 2 / opening[1] * 100 + '%';
      image.style.width = printed[0] / opening[0] * 100 + '%';
      image.style.height = printed[1] / opening[1] * 100 + '%';
    }
    image.style.objectFit = 'contain';
  };
  const supplierSizes = photo => {
    const pairs = photo.width === photo.height ? [[10,10],[14,14],[18,18]] : [[8,12],[12,18],[16,24]];
    return pairs.map((pair,index) => {
      const image = photo.width > photo.height ? [...pair].reverse() : [...pair];
      return {value:pair.join('x'),paper:image.map(value => value + 1),image:[...image],border:[0.5,0.5],sourceReview:!!photo.printSizes?.[index]?.sourceReview};
    });
  };
  // Approved draft retail, including standard shipping. Paper choice adds no surcharge.
  const printRetailPrices = [75,125,175];
  const framedRetailPrice = (photo, index, finish) => {
    const premium = ['light-walnut','dark-walnut','whitewash'].includes(finish);
    const square = photo.width === photo.height;
    const prices = premium ? (square ? [395,590,635] : [395,530,635]) : (square ? [350,560,600] : [350,485,600]);
    return prices[index];
  };
  const artistPairs = photo => photo.width === photo.height ? [{image:[12,12],paper:[13,13]},{image:[14,14],paper:[15,15]},{image:[16,16],paper:[17,17]}] : [{image:[8,12],paper:[11,14]},{image:[12,18],paper:[13,19]},{image:[16,24],paper:[17,25]}];
  // A native route can suggest only a variant belonging to this photograph.
  // Paper remains an explicit Artist choice; routing never adds an item.
  const routeSelection = (photo, params) => {
    if (params.get('review_print') !== photo.handle) return null;
    const kind = params.get('purchase');
    const variant = params.get('photo_variant');
    const id = value => String(value || '').split('/').pop();
    if (kind === 'artist') {
      const index = photo.artistEdition.sizes.findIndex(size => id(size.variantId) === variant);
      return {kind, index: index >= 0 ? index : null};
    }
    if (kind !== 'lab') return null;
    const index = photo.labCatalog.variantIds.findIndex(value => id(value) === variant);
    if (index < 0 || !photo.labCatalog.verifiedIndices.includes(index)) return {kind, index:null};
    const config = index % 13;
    return {kind, index:Math.floor(index / 26), paper:Math.floor(index % 26 / 13), format:config ? 'framed' : 'print', frame:config ? Math.floor((config-1)/2) : null, mat:config ? (config-1)%2 : null};
  };
  const initialize = (page, photo) => {
    if (page.dataset.optionsReady) return;
    page.dataset.optionsReady = 'true';
    const labels = JSON.parse(page.querySelector('[data-print-options-labels]').textContent);
    if (!window.PhotoCatalog.review) labels.fit = window.PhotoCatalog.labels.artistFit;
    const sizes = [...page.querySelectorAll('.photo-print__size-grid input')];
    const labSizes = supplierSizes(photo);
    sizes.forEach((input,index) => { input.value = labSizes[index].value; });
    const formats = [...page.querySelectorAll('[data-print-formats] input')];
    const framing = page.querySelector('[data-print-framing]');
    const artist = page.querySelector('[data-print-artist]');
    const room = page.querySelector('[data-print-room]');
    const guide = page.querySelector('.photo-print__paper-guide:not(.photo-print__artist-guide)');
    const dimensions = page.querySelector('.photo-print__dimensions');
    const diagram = page.querySelector('[data-print-diagram]');
    const sourceReview = page.querySelector('.photo-print__source-review');
    const frame = page.querySelector('[data-print-frame]');
    const purchaseStatus = page.querySelector('.photo-print__status');
    const defaultPurchaseStatus = purchaseStatus.textContent;
    const mat = page.querySelector('[data-print-mat]');
    const image = page.querySelector('[data-room-photo]');
    const eligible = photo.width > 0 && photo.height > 0;
    const labPapers = page.querySelector('[data-lab-papers]');
    const labPaperChoice = page.querySelector('[data-lab-paper-choice]');
    const renderLabPaper = () => {
      page.querySelector('[data-print-selected-paper]').textContent = labPaperChoice.selectedOptions[0].textContent;
    };
    const artistPapers = page.querySelector('[data-artist-papers]');
    const artistPaperChoice = page.querySelector('[data-artist-paper-choice]');
    const pairs = artistPairs(photo);
    const oriented = values => photo.width > photo.height ? [...values].reverse() : values;
    const inches = values => values.map(value => new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:2}).format(value)).join(' × ') + ' in';
    let artistIndex = 1;
    const artistPrices = [150, 250, 350];
    const artistPrice = index => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(artistPrices[index]) + ' USD';
    const artistTier = index => labels[['artist_small', 'artist_medium', 'artist_large'][index]];
    const renderArtistPrice = () => {
      page.querySelector('[data-print-price]').textContent = eligible ? artistPrice(artistIndex) : artistPrices.map((value, index) => artistTier(index) + ': ' + artistPrice(index)).join(' · ');
    };
    const labLabels = sizes.map(input => input.nextElementSibling.textContent);
    const labLegend = page.querySelector('.photo-print__sizes legend').textContent;
    let labIndex = Math.max(0, sizes.findIndex(input => input.checked));
    let current = 'print';
    const gallery = page.closest('photo-gallery');
    const testPreview = !!gallery?.dataset.preview && !window.PhotoCatalog.review;
    let cartBusy = false;
    let testCartButton, testCartStatus, testCartLink;
    const selectedTestItem = () => testCartItem(current === 'artist' ? page.artistLineItem : page.labLineItem);
    const renderTestCart = () => {
      if (!testPreview) return;
      const chosen = current === 'artist' ? page.artistLineItem : page.labLineItem;
      const value = window.PhotoCatalog.variant(photo,current === 'artist' ? 'artist' : 'lab',chosen?.id);
      page.querySelector('[data-print-price]').textContent = value ? window.PhotoCatalog.money(value.price) : labels.pending;
      if (!testCartButton) {
        const doc = page.ownerDocument;
        const wrapper = doc.createElement('div');
        wrapper.className = 'photo-print__test-cart';
        testCartButton = doc.createElement('button');
        testCartButton.type = 'button';
        testCartButton.className = 'photo-buyer__action';
        testCartButton.textContent = 'Add to cart';
        testCartStatus = doc.createElement('p');
        testCartStatus.setAttribute('role','status');
        testCartStatus.setAttribute('aria-live','polite');
        testCartLink = doc.createElement('a');
        testCartLink.className = 'photo-buyer__action';
        testCartLink.textContent = 'View cart';
        testCartLink.href = (window.Shopify?.routes?.root || '/') + 'cart' + (window.PhotoCatalog.preview ? '?preview_theme_id=' + gallery.dataset.previewTheme : '');
        wrapper.append(testCartButton,testCartStatus,testCartLink);
        purchaseStatus.after(wrapper);
        testCartButton.addEventListener('click', async () => {
          if (cartBusy || !page.isConnected || gallery.reviewExpired?.()) return;
          const previous = selectedTestItem();
          if (!previous) return;
          cartBusy = true;
          renderTestCart();
          await window.PhotoCatalog.hydrate(photo,true);
          if (current === 'artist') renderArtist(); else renderFramedDimensions();
          const item = selectedTestItem();
          if (!item || item.id !== previous.id || JSON.stringify(item.properties) !== JSON.stringify(previous.properties)) {
            cartBusy = false;
            renderTestCart();
            return;
          }
          cartBusy = true;
          renderTestCart();
          testCartStatus.textContent = 'Adding to cart…';
          let uncertain = true;
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})
            });
            if (!response.ok) {
              uncertain = false;
              const error = await response.json();
              throw new Error(error.description || error.message || 'This item could not be added.');
            }
            await response.json();
            testCartStatus.textContent = 'Added to cart.';
            window.location.assign(testCartLink.href);
          } catch (error) {
            // An interrupted response may already have added the item: inspect
            // the cart before retrying, so the test cannot silently add twice.
            if (uncertain) testCartStatus.textContent = 'Could not confirm the cart update. View your cart before trying again.';
            else {
              cartBusy = false;
              renderTestCart();
              testCartStatus.textContent = error.message;
            }
          }
        });
      }
      const allowed = !!selectedTestItem() && !gallery.reviewExpired?.();
      purchaseStatus.hidden = allowed;
      testCartButton.disabled = cartBusy || !allowed;
      testCartButton.textContent = cartBusy ? 'Adding to cart…' : 'Add to cart';
      if (!cartBusy) testCartStatus.textContent = allowed ? '' : 'This choice is unavailable for checkout.';
    };
    const framedSize = (index = labIndex) => {
      if (current !== 'framed') return null;
      const image = labSizes[index].image;
      const matWidth = [2,2.5,3][index];
      const profiles = {
        black:{face:0.75,depth:1.25,allowance:0.875,label:'sf_profile_painted'},
        white:{face:0.75,depth:1.25,allowance:0.875,label:'sf_profile_painted'},
        natural:{face:0.625,depth:1.0625,allowance:0.75,label:'sf_profile_natural'},
        'light-walnut':{face:0.8125,depth:1.3125,allowance:1.125,label:'sf_profile_light_walnut'},
        'dark-walnut':{face:0.8125,depth:1.1875,allowance:0.875,label:'sf_profile_dark_walnut'},
        whitewash:{face:0.75,depth:1.125,allowance:1.125,label:'sf_profile_whitewash'}
      };
      const profile = profiles[frame.value] || profiles.black;
      const outsideVerified = !!profiles[frame.value] && index >= 0 && index < 3;
      // Allowances are the independently observed regular Gallery exterior minus interior dimensions.
      const outerIn = image.map(value => value + matWidth * 2 + profile.allowance);
      const visibleMatIn = matWidth + (profile.allowance - profile.face * 2 + 0.25) / 2;
      return {supplier:'simply-framed',provisional:true,outsideVerified,outsideDepthIn:outsideVerified?profile.depth:null,paperTargetIn:[...image],imageIn:[...image],sheetIn:[...image],windowIn:image.map(value=>value-0.25),interiorIn:image.map(value=>value+matWidth*2),outerIn,matIn:matWidth,visibleMatIn,mat:mat.value,hardware:'wire',profile:{face:profile.face,depth:profile.depth,label:profile.label}};
    };
    const fractionalInches = values => values.map(value => {
      const whole = Math.floor(value);
      const numerator = Math.round((value-whole)*16);
      if (!numerator) return String(whole);
      const fractions = {2:'⅛',4:'¼',6:'⅜',8:'½',10:'⅝',12:'¾',14:'⅞'};
      return fractions[numerator] ? (whole || '') + fractions[numerator] : (whole ? whole + ' ' : '') + numerator + '/16';
    }).join(' × ') + ' in';
    const renderSizeLabels = () => sizes.forEach((input,index) => {
      const tier = artistTier(index);
      if (current === 'artist') input.nextElementSibling.textContent = tier + '\n' + inches(oriented(pairs[index].image)) + ' ' + labels.sf_image + '\n' + (pairs[index].paper ? inches(oriented(pairs[index].paper)) + ' ' + labels.sf_paper_word : labels.artist_paper_pending);
      else if (current === 'framed') input.nextElementSibling.textContent = tier + '\n' + inches(framedSize(index).imageIn) + ' ' + labels.sf_image;
      else {
        const size = labSizes[index];
        input.nextElementSibling.textContent = tier + (size ? '\n' + inches(size.paper) + ' ' + labels.sf_paper_word + '\n' + inches(size.image) + ' ' + labels.sf_image : '\n' + labels.pending);
      }
    });
    const verifiedDimensions = values => values.map(value => new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 }).format(value / 2.54)).join(' × ') + ' in (' + values.join(' × ') + ' cm)';
    // Original finish illustrations informed by the regular Gallery references.
    // Keep the mat palette independent: changing a frame must not recolor its mat.
    const frameColors = { black: '#242323', white: '#f4f4f0', natural: '#e7ddc8', 'light-walnut': '#af8050', 'dark-walnut': '#493b31', whitewash: '#eae6dd' };
    const roomColors = { black: '#292725', white: '#f2f1ed', ivory: '#ece8dc', cream: '#e9dec4' };
    formats.forEach(input => { input.name = 'review-format-' + page.dataset.photo; });
    const renderRoom = () => {
      if (current !== 'framed') return;
      const background = page.querySelector('[data-room-background]');
      if (!background.src) background.src = background.dataset.src;
      if (!image.src) Object.assign(image, { src: (()=>{const url=new URL(photo.image,location.origin);url.searchParams.set('width',800);return url.href;})(), alt: photo.alt || photo.title, width: photo.width, height: photo.height });
      const previewFrame = page.querySelector('[data-room-frame]');
      const previewMat = page.querySelector('[data-room-mat]');
      previewFrame.style.backgroundColor = frameColors[frame.value];
      previewMat.style.backgroundColor = roomColors[mat.value];
      const geometry = framedSize();
      // Generated 1536 × 1024 room: approximate outer-arm span x=237..1307.
      // Assume 80 inches for that 1070px reference; this is not measured furniture.
      // Use the same projected scale for every frame. Unknown wall/sofa depth makes
      // the scene approximate; no unsupported perspective correction is applied.
      const roomPixelsPerInch = 1070 / 80;
      previewFrame.style.width = (100 * geometry.outerIn[0] * roomPixelsPerInch / 1536) + '%';
      previewFrame.style.top = (30 - 50 * geometry.outerIn[1] * roomPixelsPerInch / 1024) + '%';
      applyPreviewGeometry(previewFrame, previewMat, image, geometry, true, page.querySelector('[data-room-window]'), page.querySelector('[data-room-core]'));
      applyFrameFinish(previewFrame, geometry, frame.value);
      const selection = [geometry ? inches(geometry.imageIn) + ' ' + labels.sf_image : labLabels[labIndex], frame.selectedOptions[0].textContent + ' frame', mat.selectedOptions[0].textContent + ' mat', labPaperChoice.selectedOptions[0].textContent];
      page.querySelector('[data-room-selection]').textContent = selection.join(' · ');
      image.alt = photo.title + ' — ' + labels.room_alt;
    };
    const imperial = new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:2});
    const metric = new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:4});
    const dualDimensions = (values, unit = 'in') => {
      const cm = unit === 'cm' ? values : values.map(value => value * 2.54);
      const inch = unit === 'cm' ? values.map(value => value / 2.54) : values;
      return inch.map(value => imperial.format(value)).join(' × ') + ' in (' + cm.map(value => metric.format(value)).join(' × ') + ' cm)';
    };
    const renderFramedDimensions = () => {
      // Route only the approved unpublished lab pilot. Keep the payload disabled
      // until a separately authorized checkout test and launch release.
      page.labLineItem = labLineItem(photo, labIndex, labPaperChoice.value, current, frame.value, mat.value);
      renderTestCart();
      page.dataset.labProduct = page.labLineItem?.productId || '';
      page.dataset.labVariant = page.labLineItem?.id || '';
      const labVariantInput = page.querySelector('[data-lab-variant]');
      if (labVariantInput) {
        labVariantInput.value = page.labLineItem?.id || '';
        labVariantInput.disabled = true;
      }
      const blackMatNote = page.querySelector('[data-black-mat-note]');
      if (blackMatNote) blackMatNote.hidden = current !== 'framed' || mat.value !== 'black';
      const framed = current === 'framed';
      const geometry = framedSize();
      page.framedGeometry = geometry;
      const notice = page.querySelector('[data-large-square-notice]');
      notice.hidden = true;
      notice.textContent = '';
      page.querySelectorAll('[data-print-frame-notice]').forEach(node => { node.textContent = labels.frame_notice; });
      page.querySelectorAll('[data-print-only-hide]').forEach(node => { node.hidden = current !== 'print'; });
      page.querySelectorAll('[data-sf-only]').forEach(node => { node.hidden = !framed; });
      page.querySelectorAll('[data-printed-border-row]').forEach(node => { node.hidden = framed; });
      page.querySelector('[data-print-outer-row]').hidden = !framed;
      page.querySelector('[data-print-frame-estimate]').hidden = true;
      diagram.hidden = current !== 'print' && !(current === 'artist' && page.artistGeometry);
      if (current === 'artist') renderArtistPrice();
      else page.querySelector('[data-print-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD',maximumFractionDigits:0}).format(framed ? framedRetailPrice(photo,labIndex,frame.value) : printRetailPrices[labIndex]) + ' USD';
      renderTestCart();
      purchaseStatus.textContent = window.PhotoCatalog.review ? (framed ? labels.sf_order_pending : defaultPurchaseStatus) : ''; 
      renderSizeLabels();
      const printSize = labSizes[labIndex];
      page.printGeometry = printSize ? {outerCm:printSize.paper.map(value=>value*2.54),paperCm:printSize.paper.map(value=>value*2.54),imageCm:printSize.image.map(value=>value*2.54)} : null;
      if (!framed) {
        delete page.dataset.framedGeometry;
        if (current === 'print' && printSize) {
          page.querySelector('.photo-print__paper-size').textContent = inches(printSize.paper);
          page.querySelector('.photo-print__image-size').textContent = inches(printSize.image);
          page.querySelector('.photo-print__border-horizontal').textContent = inches([printSize.border[0]]);
          page.querySelector('.photo-print__border-vertical').textContent = inches([printSize.border[1]]);
          if (window.PhotoBuyer?.diagram) window.PhotoBuyer.diagram(diagram,printSize,photo);
        }
        return;
      }
      page.dataset.framedGeometry = 'simply-framed';
      page.querySelector('.photo-print__sizes legend').textContent = labels.size;
      page.querySelector('.photo-print__paper-size').textContent = inches(geometry.paperTargetIn) + ' — ' + labels.sf_paper_target;
      page.querySelector('.photo-print__image-size').textContent = inches(geometry.imageIn);
      page.querySelector('[data-print-outer]').textContent = fractionalInches(geometry.outsideVerified ? [...geometry.outerIn,geometry.outsideDepthIn] : geometry.outerIn);
      page.querySelector('[data-sf-profile]').textContent = labels[geometry.profile.label];
      page.querySelector('[data-sf-mat-width]').textContent = fractionalInches([geometry.matIn]);
      page.querySelector('[data-sf-visible-mat]').textContent = labels.sf_calculated;
      page.querySelector('[data-sf-hardware-status]').textContent = labels.sf_hardware_pending;
      sourceReview.hidden = true;
    };
    const renderArtist = () => {
      renderArtistPrice();
      const pair = pairs[artistIndex];
      const imageSize = oriented(pair.image);
      const paperSize = pair.paper ? oriented(pair.paper) : null;
      page.artistGeometry = paperSize ? {outerCm:paperSize.map(value=>value*2.54),paperCm:paperSize.map(value=>value*2.54),imageCm:imageSize.map(value=>value*2.54)} : null;
      diagram.hidden = !paperSize;
      if (paperSize && window.PhotoBuyer?.diagram) window.PhotoBuyer.diagram(diagram,{paper:paperSize,image:imageSize,border:paperSize.map((value,axis)=>(value-imageSize[axis])/2)},photo);
      renderSizeLabels();
      sizes.forEach((input, index) => { input.checked = eligible && index === artistIndex; });
      page.querySelector('[data-artist-image]').textContent = eligible ? inches(imageSize) : labels.pending;
      page.querySelector('[data-artist-paper]').textContent = eligible && paperSize ? inches(paperSize) + (artistIndex === 1 && photo.width !== photo.height ? ' (A3+)' : '') : labels.artist_paper_pending;
      page.querySelector('[data-artist-border-horizontal]').textContent = eligible && paperSize ? inches([(paperSize[0] - imageSize[0]) / 2]) : labels.pending;
      page.querySelector('[data-artist-border-vertical]').textContent = eligible && paperSize ? inches([(paperSize[1] - imageSize[1]) / 2]) : labels.pending;
      page.querySelector('[data-artist-fit]').textContent = eligible ? (paperSize ? labels.fit : labels.artist_pairing_pending) : labels.unconfirmed;
      const variant = paperSize ? photo.artistEdition?.sizes[artistIndex] : null;
      page.dataset.artistProduct = variant ? photo.artistEdition?.productId || '' : '';
      page.dataset.artistVariant = variant?.variantId || '';
      page.querySelector('[data-artist-variant]').value = variant?.variantId?.split('/').pop() || '';
      page.artistLineItem = paperSize ? artistLineItem(photo, artistIndex, artistPaperChoice.value) : null;
      renderTestCart();
      page.querySelector('[data-artist-order-status]').textContent = window.PhotoCatalog.review ? labels.artist_inventory_pending : window.PhotoCatalog.labels.editionLimit;
      renderTestCart();
      sourceReview.hidden = true;
      if (page.dataset.combinedReady) window.PhotoCombined?.updatePurchasePreview(page);
    };
    const setFormat = value => {
      if (current !== 'artist') labIndex = Math.max(0, sizes.findIndex(input => input.checked));
      current = value;
      formats.forEach(input => { input.checked = input.value === value; });
      const isArtist = value === 'artist';
      const isFramed = value === 'framed';
      page.dataset.format = value;
      page.querySelector('[data-print-delivery-summary]').textContent = labels['delivery_' + value];
      page.querySelector('[data-print-delivery-intro]').textContent = !isArtist ? labels.sf_delivery_intro : labels.delivery_intro;
      framing.hidden = !isFramed;
      framing.disabled = !isFramed;
      room.hidden = !isFramed;
      artist.hidden = !isArtist;
      artistPapers.disabled = !isArtist;
      labPapers.disabled = isArtist;
      if (!isArtist) renderLabPaper();
      guide.hidden = false;
      artistPapers.hidden = !isArtist;
      dimensions.hidden = isArtist || !sizes.length;
      diagram.hidden = isArtist;
      sourceReview.hidden = isArtist || !photo.printSizes?.[labIndex]?.sourceReview;
      page.querySelectorAll('[data-print-lab-only]').forEach(node => { node.hidden = isArtist; });
      page.querySelector('.photo-print__sizes legend').textContent = labels.size;
      sizes.forEach((input, index) => {
        input.disabled = isArtist && !eligible;
        input.checked = isArtist ? index === artistIndex && eligible : index === labIndex;
        input.nextElementSibling.textContent = isArtist ? eligible ? inches(oriented(pairs[index].image)) + ' image' : artistTier(index) + ' — ' + artistPrice(index) + ' (' + labels.artist_dimensions_pending + ')' : labLabels[index];
      });
      if (isArtist) renderArtist();
      if (!isArtist && sizes[labIndex]) sizes[labIndex].dispatchEvent(new Event('change', { bubbles: true }));
      if (!isArtist && window.PhotoBuyer?.diagram) window.PhotoBuyer.diagram(diagram, labSizes[labIndex], photo);
      renderFramedDimensions();
      renderRoom();
    };
    formats.forEach(input => input.addEventListener('change', () => { if (input.checked) setFormat(input.value); }));
    sizes.forEach((input, index) => {
      // Capture artist changes before existing lab dimension/diagram handlers.
      input.addEventListener('change', event => {
        if (input.checked && current === 'artist') {
          event.stopImmediatePropagation();
          artistIndex = index;
          renderArtist();
        }
      }, true);
      input.addEventListener('change', () => { if (input.checked && current !== 'artist') { labIndex = index; renderFramedDimensions(); renderRoom(); } });
    });
    labPaperChoice.addEventListener('change', () => { if (current !== 'artist') { renderLabPaper(); renderFramedDimensions(); renderRoom(); } });
    artistPaperChoice.addEventListener('change', () => { if (current === 'artist') renderArtist(); });
    frame.addEventListener('change', () => { renderFramedDimensions(); renderRoom(); });
    mat.addEventListener('change', () => { renderFramedDimensions(); renderRoom(); });
    const requested = routeSelection(photo, new URLSearchParams(location.search));
    let initialFormat = !window.PhotoCatalog.review && !photo.commercePaths?.lab && photo.commercePaths?.artist ? 'artist' : 'print';
    if (requested?.kind === 'artist' && (window.PhotoCatalog.review || photo.commercePaths?.artist)) {
      initialFormat = 'artist';
      if (requested.index !== null) artistIndex = requested.index;
    } else if (requested?.kind === 'lab' && (window.PhotoCatalog.review || photo.commercePaths?.lab) && requested.index !== null) {
      initialFormat = requested.format;
      labIndex = requested.index;
      sizes.forEach((input,index) => { input.checked = index === labIndex; });
      labPaperChoice.value = ['photo-rag','premium-photo-luster'][requested.paper];
      if (requested.format === 'framed') {
        frame.value = ['white','black','natural','light-walnut','dark-walnut','whitewash'][requested.frame];
        mat.value = ['white','black'][requested.mat];
      }
    }
    setFormat(initialFormat);
    if (!window.PhotoCatalog.review) {
      page.querySelector('.photo-print__review')?.setAttribute('hidden','');
      window.PhotoCatalog.hydrate(photo).then(() => {
        if (page.isConnected) { if (current === 'artist') renderArtist(); else renderFramedDimensions(); }
      });
    }
  };
  const artistLineItem = (photo, index, paper) => {
    const papers = { white: 'Aurora Art White 300', natural: 'Aurora Art Natural 300', baryta: 'Big Bend Baryta 310' };
    const variant = photo.artistEdition?.sizes[index];
    if (!variant || !artistPairs(photo)[index]?.paper) return null;
    if (!papers[paper]) throw new Error('An approved Artist Edition paper is required.');
    return { id: variant.variantId.split('/').pop(), quantity: 1, properties: { Paper: papers[paper], 'Image size': variant.imageIn.join(' × ') + ' in', 'Paper size': variant.paperIn.join(' × ') + ' in', _Edition: 'Artist Edition', _Photograph: photo.handle }, orderable: window.PhotoCatalog.orderable(photo,'artist',variant.variantId) };
  };
  const labLineItem = (photo, sizeIndex, paper, format, frame, mat) => {
    const catalog = photo.labCatalog;
    if (catalog) {
      if (!Number.isInteger(sizeIndex) || sizeIndex < 0 || sizeIndex > 2 || !['print','framed'].includes(format)) return null;
      const papers = ['photo-rag','premium-photo-luster'];
      const finishes = ['white','black','natural','light-walnut','dark-walnut','whitewash'];
      const finishLabels = ['White','Black','Natural','Light Walnut','Dark Walnut','Whitewash'];
      const paperIndex = papers.indexOf(paper);
      const frameIndex = finishes.indexOf(frame);
      const matIndex = ['white','black'].indexOf(mat);
      if (paperIndex < 0 || format === 'framed' && (frameIndex < 0 || matIndex < 0)) return null;
      const configurationIndex = format === 'print' ? 0 : 1 + frameIndex * 2 + matIndex;
      const variantIndex = sizeIndex * 26 + paperIndex * 13 + configurationIndex;
      const variantId = catalog.variantIds[variantIndex];
      if (!variantId || !catalog.verifiedIndices.includes(variantIndex)) return null;
      const size = supplierSizes(photo)[sizeIndex];
      const configuration = format === 'print' ? 'Print Only' : 'Framed — ' + finishLabels[frameIndex] + ' / ' + (matIndex ? 'Black' : 'Paper White') + ' mat';
      return {id:variantId,productId:catalog.productId,sku:catalog.skuPrefix + '-' + (sizeIndex+1) + '-' + (paperIndex+1) + '-' + configurationIndex,price:(format === 'print' ? printRetailPrices[sizeIndex] : framedRetailPrice(photo,sizeIndex,frame)).toFixed(2),quantity:1,properties:{Paper:paperIndex ? 'Simply Framed Premium Photo Luster' : 'Hahnemühle Photo Rag','Image size':size.image.join(' × ') + ' in','Paper size':(format === 'print' ? size.paper : size.image).join(' × ') + ' in',Configuration:configuration,_Edition:'Lab Print',_Photograph:photo.handle},orderable:window.PhotoCatalog.orderable(photo,'lab',variantId)};
    }
    const pilot = photo.labPilot;
    if (!pilot || pilot.status !== 'DRAFT' || !pilot.inventoryProtected || !['print', 'framed'].includes(format)) return null;
    const matches = pilot.variants.filter(variant => variant.sizeIndex === sizeIndex && variant.paper === paper && variant.format === format && (format === 'print' || variant.frame === frame && variant.mat === mat));
    if (matches.length !== 1 || !matches[0].mappingVerified) return null;
    const variant = matches[0];
    return {id: variant.variantId.split('/').pop(), productId: pilot.productId, sku: variant.sku, price: variant.price, quantity: 1, properties: {Paper: variant.paperLabel, 'Image size': variant.imageIn.join(' × ') + ' in', Configuration: variant.configuration, _Edition: 'Lab Pilot', _Photograph: photo.handle}, orderable: false};
  };
  window.PhotoPrintOptions = { routeSelection, initialize, artistLineItem, labLineItem, applyPreviewGeometry, applyFrameFinish, supplierSizes, framedRetailPrice, testCartItem };
  document.addEventListener('photo-print:created', event => initialize(event.detail.page, event.detail.photo));
  // Defer scripts may run after the gallery's cached review fetch has completed.
  document.querySelectorAll('photo-gallery').forEach(gallery => {
    gallery.querySelectorAll('.photo-print').forEach(page => {
      const photo = gallery.review?.photos.find(item => item.handle === page.dataset.photo);
      if (photo) initialize(page, photo);
    });
  });
})();
